import logo from './logo.svg';
import './App.css';

import Page from "./page.js"

function App() {
  return (
    <div className="App">

      <Page/>

    </div>
  );
}

export default App;
